import * as THREE from "three";
import { TweenLite, Power1 } from "gsap";
import Orbit from "../../utils/orbit";

import cameraWalkThroughData from "../../data/camera_walkthrough.json";

export default class Camera {
  /**
   * Camera States
   */
  static States = {
    LOCK: "lock",
    IDLE: "idle",
    WALKTHROUGH: "walkThroug",
  };

  /**
   * Get current camera state
   */
  get State() {
    return this._state;
  }

  /**
   * Set camera state
   * @param {Camera.States} state - Camera States (LOCK / IDLE / WALKTHROUGH)
   */
  set State(state) {
    this._state = state;

    if (state === Camera.States.IDLE) {
      this.controls.enableZoom = true;
      this.controls.enabled = true;
    } else {
      this.controls.enableZoom = false;
      this.controls.enabled = false;
    }
  }

  constructor(renderer, isMobile) {
    const ratio = window.innerWidth / window.innerHeight;

    this.camera = new THREE.PerspectiveCamera(75, ratio, 0.1, 10000);
    this.camera.position.z = isMobile ? 1.8 : 0.8; // Default distance
    this.camera.position.y = 0.5;

    const OrbitControlsPlus = Orbit(THREE);

    this.controls = new OrbitControlsPlus(this.camera, renderer.domElement);
    this.controls.target.set(0, 0.3, 0);

    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.1;
    this.controls.rotateSpeed = 0.2;
    this.controls.screenSpacePanning = false;
    this.controls.enableZoom = true;
    this.controls.zoomSpeed = 1;
    this.controls.minDistance = isMobile ? 1 : 0.8; // close up
    this.controls.maxDistance = isMobile ? 2 : 1.5; // open
    this.controls.maxPolarAngle = Math.PI / 2;
    this.controls.enableKeys = false;
    this.controls.enablePan = false;
    this.controls.zoom0 = 0;
    this.controls.update();

    this.State = Camera.States.IDLE;
    this.moveCamera(0, 90, 1, 0);
  }

  /**
   * Convert Rad to Deg
   * @param {number} deg - Number in degs
   */
  degToRad = (deg) => {
    return (deg * Math.PI) / 180;
  };

  /**
   * Convert Deg to Rad
   * @param {number} rad - Number in radians
   */
  radToDeg = (rad) => {
    return (rad * 180) / Math.PI;
  };

  /**
   * Tween camera to specific angle
   */
  moveCamera = (x, y, zoom, time = 0.5, delay = 0, completeHandler) => {
    x = this.degToRad(x);
    y = this.degToRad(y);

    var posTo = {
      y: this.controls.getAzimuthalAngle(),
      x: this.controls.getPolarAngle(),
      zoom: this.controls.getZoom(),
    };
    TweenLite.to(posTo, time, {
      x: x,
      y: y,
      delay: delay,
      zoom: zoom,
      ease: Power1.easeOut,
      onUpdate: () => {
        this.controls.setPolarAngle(posTo.x);
        this.controls.setAzimuthalAngle(posTo.y);
        this.controls.setZoom(posTo.zoom);
      },
      onComplete: completeHandler,
    });
  };

  zoomCamera = (direction, time = 0.25, completeHandler) => {
    const zoom = direction < 0 ? 1.01 : 0.99;
    var posTo = {
      zoom: this.controls.getZoom(),
    };

    TweenLite.to(posTo, time, {
      zoom: zoom,
      ease: Power1.easeOut,
      onUpdate: () => {
        this.controls.setZoom(posTo.zoom);
      },
      onComplete: () => {
        console.log(this.controls.getZoom());
        typeof completeHandler === 'function' && completeHandler();
      },
    });

    /*
    if (direction < 0) {
      this.controls.dollyOut();
    } else {
      this.controls.dollyIn();
    }
    */
  };

  /**
   * Zoom should be in the decimals. Example: 0.98, 1.01
   * @param {double} zoom 
   */
  zoomCameraTo = (zoom = 1.0, time = 0.25) => {
    var posTo = {
      zoom: this.controls.getZoom(),
    };

    TweenLite.to(posTo, time, {
      zoom: zoom,
      ease: Power1.easeOut,
      onUpdate: () => {
        this.controls.setZoom(posTo.zoom);
      }
    });
  };

  startWalkThrough = () => {
    this.State = Camera.States.WALKTHROUGH;
    this.doWalkThrough(0);
  };

  finishWalkthrough = () => {
    this.setCamState(Camera.States.IDLE);
  };

  doWalkThrough = (index) => {
    if (this.State !== Camera.States.WALKTHROUGH) return;

    const data = cameraWalkThroughData[index];
    this.moveCamera(data.angleX, data.angleY, data.zoom, data.time, 3, () => {
      const next = index + 1;

      if (next === cameraWalkThroughData.length) this.doWalkThrough(0);
      else this.doWalkThrough(next);
    });
  };

  onCamFinish = () => {
    this.walkThroughIndex += 1;

    if (this.walkThroughIndex === cameraWalkThroughData.length)
      this.walkThroughIndex = 0;

    this.doWalkThrough();
  };

  update = () => {

    
    this.controls.update();
     //console.log('y: ' , this.radToDeg(this.controls.getAzimuthalAngle()));
     //console.log('x: ' , this.radToDeg(this.controls.getPolarAngle()));
  };
}
